import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "reviews",
    object: "review",
    header: [
      { text: "Usuario", value: "short_user" },
      { text: "Descripción", value: "comment" },
      { text: "Tags", value: "tags" },
      { text: "Calificación", value: "rating" },
      { text: "Creación", value: "created_at" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    roles: [],
    options: {
      sortBy: ["_id"],
      sortDesc: [true],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
